import ResidenceSection from './ResidenceSection';

export default ResidenceSection;
